var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aipage"},[_c('extraPage',{attrs:{"content":_vm.content},on:{"change":_vm.changeTab}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }